import React from 'react'
import { Box, Flex, Divider } from 'rebass'
import { colors, fonts, fontSizes, fontWeights } from '../theme'
import Inputfield from '../elements/Form/Inputfield';
import PrimaryButton from '../elements/Button/PrimaryButton';
import styled from 'styled-components'
import Title from '../elements/Text/Title'

const DetailsContainer = styled(Box)`
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[3] + 'px'};
  &:first-letter {
    font-weight: bold;
    font-size: ${fontSizes[6] + 'px'};
  }
  color: ${colors.greyDark};
`
const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`
const SubmitButton = styled(PrimaryButton)`
  padding: 12px 18px;
  box-shadow: none;
  font-size: ${fontSizes[3] + 'px'};
  transition: all 0.3s linear;

  &:hover{
    color: ${colors.secondary};
    background-color: ${colors.primary}!important;
  }
`
const Request = () => (
  <Box px={5} py={6} style={{ textAlign: 'center' }}>
    <Title color={colors.primary}>Submit Your Request</Title>
    <TextSeparator />
    <form action='https://formspree.io/jshubham0094@gmail.com' method="POST">
      <Flex flexDirection={["column",,"row"]}>
        <Box w={[1,,1/2]} p={[0,,2]} >
          <Inputfield
            type="text"
            name="Name"
            label="Full Name"
            color={colors.primary}
            required
          />
          <Inputfield
            type="email"
            name="Email"
            label="Email"
            color={colors.primary}
            required
          />
        </Box>
        <Box w={[1,,1/2]} p={[0,,2]}>
          <Inputfield
            type="number"
            name="Phoneno"
            label="Phone No."
            color={colors.primary}
            required
          />
          <Inputfield
            type="text"
            name="Message"
            label="Message"
            color={colors.primary}
            required
          />
        </Box>
      </Flex>
      <SubmitButton type="submit">Submit</SubmitButton>
    </form>
  </Box>
)

export default Request



// WEBPACK FOOTER //
// ./src/pages/request.js